import { Component } from '@angular/core';
import { MfeLoaderService } from 'src/app/MFE/mfe-loader.service';
import { environment } from 'src/environments/environment';
import { BaseMfeComponent } from '../base-mfe.component';

@Component({
  selector: 'app-mfe-footer',
  template: '<div #mfeContainer></div>',
})

export class MFE_FooterComponent extends BaseMfeComponent {
  protected configKey = '__MFE_FOOTER_RUNTIME_CONFIG__';
  protected tagName = 'app-mfe-footer';
  protected scriptPath = `${environment.mfeUrl}/plataforma/footer`;

  constructor(mfeLoaderService: MfeLoaderService) {
    super(mfeLoaderService);
  }
}